// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import history from '../../../../../../services/history';
import styles from './styles';

const ProfileMenuRestriction = (props) => {
  const { classes } = props;
  const text = 'To make any changes to your buslness information please contact us at';
  const email = 'cs@sellitback.com';

  return (
    <div className={classes.container}>
      <span className={classes.text}>{text}</span>
      <span
        className={classes.email}
        role="button"
        aria-hidden="true"
        onClick={() => history.push('/contact')}
      >
        {email}
      </span>
    </div>
  );
};

ProfileMenuRestriction.propTypes = {
  classes: PropTypes.object,
};

ProfileMenuRestriction.defaultProps = {
  classes: {},
};

export default withStyles(styles)(ProfileMenuRestriction);
